export default {"src":"/_next/static/media/helmet.83ce3e98.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};